import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Row, Col, FormGroup, Radio}  from 'react-bootstrap';
import {Field, reduxForm, reset, submit, stopSubmit, setSubmitFailed} from 'redux-form';
import LocaleStrings from 'Languages';

class HeaderControl extends Component {
    constructor(props) {
        super(props);
 
    }

    // renderFieldRadio(field){
    //     return(
    //       <div className='' style={{display: 'inline'}}>
    //         <label className="custom-container-radio" style={{marginRight: '20px'}}>
    //           {field.label}
    //           <input
    //             {...field.input}  
    //             type={field.type}
    //           />
    //           <span className="radiomark"></span>
    //         </label>
    //       </div>
    //     );
    //   }
      

    render(){
        return(
          <Row>
              <div className="col-sm-3 ">
              <div className="control-header-title"> 
                  {LocaleStrings.menu_website_heading_controls_fixed_top}
              </div> 
              </div>
              <div className="col-sm-3">
              <div className="control-header-title">
              {LocaleStrings.menu_website_heading_controls_header_height}
              </div>
            <div>
                <input type="text" className="header-control-input" />
                </div>
              
              </div>
              <div className="col-sm-3">
              <div className="control-header-title">
              {LocaleStrings.menu_website_heading_controls_background_color}
              </div>
              <div>
                <input type="text" className="header-control-input" />
                </div>
              
              </div>
              <div className="col-sm-3">
              <div className="control-header-title">
              {LocaleStrings.menu_website_heading_controls_text_color}
              </div>
              <div>
                <input type="text" className="header-control-input-dark" />
                </div>
              </div>
          </Row>

        );
    }

}


function mapStateToProps(state){
    return {
        session: state.session,
    };
  }
  
  export default connect(mapStateToProps)(HeaderControl);